<script>
import options from './StreamDonationQrCode.options'
export default options
</script>

<template>
  <article class="kb-stream-donation-qr-code" :class="[`kb-stream-donation-qr-code--${variation}`, border ? `kb-stream-donation-qr-code--${border}` : null]">
    <h2 class="kb-stream-donation-qr-code__title">Støt her</h2>
    <div class="kb-stream-donation-qr-code__qr">
      <img
        v-if="qrImgUrlBase"
        :src="`data:image/png;base64, ${qrImgUrlBase}`"
        alt="QR-kode"
      />
      <div v-else class="kb-stream-donation-qr-code__spinner"></div>
    </div>
  </article>
</template>
